import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';

import firstImage from '../../../assets/images/warehouse.png';
import secondImage from '../../../assets/images/information.png';
import Trash from '../../../assets/images/trash.png';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Table, Tabs, Modal, Row, Col, Button, Form, Accordion } from 'react-bootstrap';
import { faArrowLeft, faPaperPlane, faPaperclip, faCircleXmark, faFileArrowDown } from '@fortawesome/free-solid-svg-icons';
import { Step, StepLabel, Stepper } from '@mui/material';
import Offline from '../../../assets/images/offline.png';
import Pack from '../../../assets/images/n_package.png';
import Docmnt from "../../../assets/images/google-docs.png";
import Newon from '../../../assets/images/newon.png';
// import Trash from "../../../assets/images/trash.png";
import Export from "../../../assets/images/export.svg";
import Radown from "../../../assets/images/radown.png";
import Bin from "../../../assets/images/bin.png";
import { toast } from 'react-toastify';
import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { DOWNLOADFILES, HANDLERRDETAILS,RECOVERYDETAILS, HANDLERUPDATE, MSGSTATUSUPDATE, SAVECONVO } from '../../../Utils/conts.js';
import { saveAs } from "file-saver";
import { useUserCheckQuery } from '../../../redux/services/Auth.js';

const MessageRecovery = () => {
    const isMounted = useRef(false);
    const [recoveryDetails, seRecoveryDetails] = useState({});
    const [recoveryAspects, setRecoveryAspects] = useState([
        { warehouse_check: false, warehouse_check_date: '', contacted_agent: false, contacted_agent_date: '' }
    ]);

    const [allFeedback, setAllFeedback] = useState(null);
    const [selectedFeedback, setSelectedFeedback] = useState(null);
    const [selectedButton, setSelectedButton] = useState('all');

    const [showModalUpload, setShowModalUpload] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [files, setFiles] = useState([]);
    const [galleryFiles, setGalleryFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);
    const [userDetails, setUserDetails] = useState();

    const orgType = localStorage.getItem('OrgType')
    const storedData = localStorage.getItem('RecoveryEdit');

    const [selectedFile, setSelectedFile] = useState("");
    const [selectedDelFile, setSelectedDelFile] = useState({
        index: null,
        id: null,
    });

    const { data: myData } = useUserCheckQuery('', {
        // skip: pageDetails.pagesize === 0,
      });
      useEffect(() => {
        if (myData?.response_data) {
          setUserDetails(myData?.response_data);
        }
      }, [myData]);

    const loadDetails = async (ms, edt) => {
        try {
            const res = await withRFSToken.post(RECOVERYDETAILS, { service_recovery_id: storedData })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    if (res.data.response_code === 200) {
                        setGalleryFiles(innerData.gallery)
                        if (ms === 'M') {
                            if (selectedButton == 'all') {
                                setMsgFormData({});
                                setMsgFiles([]);
                                setAllFeedback(innerData?.handlerConversation);
                                setSelectedFeedback(innerData);
                            }
                        } else {
                            if (innerData) {
                                seRecoveryDetails(innerData);
                                setRecoveryAspects(innerData.handler_action.length > 0 ? innerData.handler_action : [{ warehouse_check: false, warehouse_check_date: '', contacted_agent: false, contacted_agent_date: '' }])
                            }

                            if (selectedButton == 'all') {
                                // const innerData = JSON.parse(localStorage.getItem('RecoveryEdit'))
                                // console.log("🚀 ~ useEffect ~ innerData:", innerData)
                                setAllFeedback(innerData?.handlerConversation);
                                setSelectedFeedback(innerData);
                            }
                        }
                    } else { toast.error(res.data.response_msg) }


                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        if (isMounted.current) return;

        loadDetails('L')

        isMounted.current = true;
    }, []);
    // RECOVERY ASPECTS START
    const handleAddAspect = () => {
        if (recoveryAspects.length < 5) {
            const newAspect = { warehouse_check: false, warehouse_check_date: '', contacted_agent: false, contacted_agent_date: '' };
            setRecoveryAspects([...recoveryAspects, newAspect]);
            // setFormData(prev => ({
            //     ...prev,
            //     handler_action: [...prev.handler_action, newAspect]
            // }));
        }
    };

    // Function to handle removing a specific aspect
    const handleRemoveAspect = (index) => {
        const updatedAspects = recoveryAspects.filter((_, i) => i !== index);
        setRecoveryAspects(updatedAspects);
        // setFormData(prev => ({
        //     ...prev,
        //     handler_action: updatedAspects
        // }));
    };

    // Function to handle input change for each row
    const handleInputChange = (index, field, value) => {
        const updatedAspects = [...recoveryAspects];
        updatedAspects[index][field] = value;

        setRecoveryAspects(updatedAspects);
        // setFormData(prev => ({
        //     ...prev,
        //     handler_action: updatedAspects
        // }));
    };
    // RECOVERY ASPECTS START
    // TABS START

    const handleButtonClick = (button, details) => {
        setSelectedButton(button);
        if (button == 'all') {
            setSelectedFeedback(null);
            // const collectFeedback = recoveryDetails?.stations?.flatMap(fb => fb.handlerConversation)
            const collectFeedback = JSON.parse(localStorage.getItem('RecoveryUpdate'))
            console.log("🚀 ~ handleButtonClick ~ collectFeedback:", collectFeedback)
            setAllFeedback(collectFeedback?.handlerConversation);
        } else {
            setSelectedFeedback(details);
        }
        if (button !== selectedButton) {
            // // setFormData({});
            // setFiles([]);
        } else {

        }

    };
    const [expanded, setExpanded] = useState(false);

    // const toggleExpandAll = () => {
    //     setExpanded(!expanded);
    // };
    const [expandedKeys, setExpandedKeys] = useState([]);

    const toggleExpandAll = (pos) => {
        if (pos == 'all') {
            if (expandedKeys.length === allFeedback?.length) {
                setExpandedKeys([]); // Collapse all
            } else {
                setExpandedKeys(allFeedback.map((_, index) => index.toString())); // Expand all
            }
        } else {
            if (expandedKeys.length === selectedFeedback?.handlerConversation?.length) {
                setExpandedKeys([]); // Collapse all
            } else {
                setExpandedKeys(selectedFeedback.handlerConversation.map((_, index) => index.toString())); // Expand all
            }
        }

    };
    const toggleAccordionItem = async (index, msg, pos) => {
        setExpandedKeys(prevKeys =>
            prevKeys.includes(index.toString())
                ? prevKeys.filter(key => key !== index.toString()) // Remove key to collapse
                : [...prevKeys, index.toString()] // Add key to expand
        );
        if (msg.is_seen === 0) {
            try {
                const res = await withRFSToken.post(MSGSTATUSUPDATE, { conversation_id: msg.conversation_id })
                    .then(function (res) {
                        // const innerData = res.data.response_data;
                        if (res.data.response_code === 200) {
                            loadDetails(pos);
                        } else { toast.error(res.data.response_msg) }
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    };

    //TABS END
    const conversationChange = (event) => {
        const { name, value, } = event.target;
        setMsgFormData(prevFormData => {
            const newFormData = { ...prevFormData, [name]: value };

            return newFormData;
        });
    }
    // MSG IMAGE UPLOAD START
    const msgFileInputRef = useRef(null);
    const [msgShowModalUpload, setMsgShowModalUpload] = useState(false);
    const [msgselectedRowId, setMsgSelectedRowId] = useState(null);
    const [msgFiles, setMsgFiles] = useState([]);
    const [msgbase64Files, setMsgBase64Files] = useState([]);
    const [msgFormData, setMsgFormData] = useState({});

    const msgHandleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setMsgFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        msgGetBase64(droppedFiles[0]);
    };

    const msgHandleDragOver = (e) => {
        e.preventDefault();
    };

    const msgHandleDeleteFile = (index) => {
        setMsgFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        // base64Files.splice(index, 1);
        setMsgBase64Files((prevBase64Files) => {
            const newBase64Files = [...prevBase64Files];
            newBase64Files.splice(index, 1);

            // Update local storage
            // setFormData((prevFormData) => {
            //     const newFormData = { ...prevFormData, base64Files: newBase64Files };
            //     return newFormData;
            // });
            return newBase64Files;
        });
        setMsgFormData((prevFormData) => {
            const newFiles = [...prevFormData.files]; 
            newFiles.splice(index, 1); 
            return { ...prevFormData, files: newFiles };
        });
    };

    const msgHandleBrowseFiles = (e) => {
        e.preventDefault();
        msgFileInputRef.current.click();
    };

    function msgGetBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setMsgBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const msgHandleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];
        let filesProcessed = 0;

        // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
        const existingBase64Files = msgFormData?.base64Files || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    // const newBase64Files = filesWithBase64.map((obj) => obj.base64);
                    const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                    // setFiles(newFiles);
                    setMsgFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setMsgBase64Files(mergedBase64Files);
                    setMsgFormData((prevFormData) => {
                        const newFormData = { ...prevFormData, files: mergedBase64Files, base64Files: mergedBase64Files };

                        return newFormData;
                    });
                }
            };
            reader.readAsDataURL(file);
        });
    };
    // MSG IMAGE UPLOAD END

    const sendMessage = async (stn) => {
        const updateData = {
            service_recovery_id: recoveryDetails.service_recovery_id,
            handler_feedback_id: recoveryDetails.handler_feedback_id,
            conversation_text: msgFormData.conversation_text,
            files: msgFormData.files
        }
        try {
            const res = await withRFSToken.post(SAVECONVO, updateData)
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        toast.success(res.data.response_msg);
                        setMsgFormData({})
                        loadDetails('M', JSON.parse(localStorage.getItem('RecoveryEdit')))
                    } else {
                        toast.error(res.data.response_msg);
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // START GALLERY 
    const [galleryViewOpen, setGalleryViewOpen] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [isTopDel, setIsTopDel] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const showGalleryView = () => {
        setGalleryViewOpen(true);
    };
    const galleryViewclose = () => {
        setGalleryViewOpen(false);
        setSelectedRows([]);
    };
    const handleCheckboxChange = (file, isChecked) => {
        if (isChecked) {
            // setSelectedRows([...selectedRows, file]);
            setSelectedRows((prevSelectedRows) => [
                ...prevSelectedRows,
                { attachment_id: file.id, attachment_type: file.attachment_type },
            ]);
        } else {
            setSelectedRows(
                selectedRows.filter((row) => row.attachment_id !== file.id)
            );
        }
    };
    const multipleDownload = async () => {
        const res = await withRFSToken.post(DOWNLOADFILES, { service_recovery_id: storedData, attachments: selectedRows, })
            .then(function (res) {
                if (res.data.response_code == 200) {
                    const downloadUrl = res.data.response_data;
                    const a = document.createElement("a");
                    a.href = downloadUrl;
                    a.download = "download.zip"; // You can set a default filename here
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    toast.success("Downloaded Successfully");
                } else {
                    toast.error(res.data.response_msg);
                }
            });
    };
    const handleDeleteImageTop = () => {
        if (selectedRows.length > 0) {
            setShowConfirmation(true);
            setIsTopDel(true);
        } else {
            toast.error("Please select at least one image");
        }
    };

    function extractPath(url) {
        try {
            let urlObject = new URL(url);
            let path = urlObject.pathname.substring(1);
            return path;
        } catch (error) {
            console.error("Invalid URL:", error);
            return null;
        }
    }

    const handleDownload = async (imageUrl, imageName) => {
        const path = extractPath(imageUrl);
        const res = await withRFSToken
            .post("get-file-blob", {
                file_path: path,
            })
            .then((response) => {
                const pdfData = atob(response.data.response_data.file_base64);
                const byteNumbers = new Array(pdfData.length);
                for (let i = 0; i < pdfData.length; i++) {
                    byteNumbers[i] = pdfData.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {
                    type: response.data.response_data.mime_type,
                });
                saveAs(blob, imageName);
            })
            .catch((error) => {
                console.error("Error during the file download:", error);
                alert("Could not download the file");
            });
    };

    const handleFileClick = (file) => {
        setSelectedFile(file);
        // setImgShow(true);
    };

    const handleDeleteImage = (index, id, type) => {
        setSelectedDelFile({ index, id, type });
        setShowConfirmation(true);
    };
    // END GALLERY 

    const findPrimary = selectedFeedback?.attachments?.filter((attachment) => attachment.primary === 1);
    const [highlightedFile, setHlightedFile] = useState("");
    const [imgShow, setImgShow] = useState(false);
    const handleImageClick = (file) => {
        setHlightedFile(file);
        setImgShow(true);
    };
    const handleClose = () => {
        setImgShow(false);
        setHlightedFile("");
    };

    return (
        <div className="">
            {console.log('formData', msgFormData)}
            {/* {console.log('recoveryAspects', recoveryAspects)}
            {console.log('selectedFeedback', selectedFeedback)} */}
            <Header />
            <div className="page-body-wrapper schedule">
                <LeftMenu />
                <div className="main-panel rounded">
                    <div className="mainTab">
                        <Link to={'/ServiceRecovery'} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
                        {/* <div className='main_truck'> */}
                        <Row>
                            <Col sm='9'>
                                <div className='missing_info my-3 h-100'>
                                    <div className='text-center text_header mb-3'>
                                        <h3>Attachment or Messages</h3>
                                        <span>This is all station attachment or messages</span>
                                    </div>
                                    <div className='chat_bg'>
                                        <Row>
                                            <Col md={3}>
                                                <div className='left_side min_hight'>
                                                    <ul>
                                                        <li>
                                                            <Link to="#" className={`d-flex ${selectedButton === 'all' ? 'active' : ''}`}>
                                                                <div> <img src={Offline} /> </div>
                                                                <div>
                                                                    <h3>{selectedFeedback?.created_by}</h3>
                                                                    <span>Airline</span>
                                                                </div>
                                                            </Link>
                                                        </li>
                                                        {recoveryDetails?.stations?.map((station, index) => (
                                                            <React.Fragment key={index}>
                                                                <li>
                                                                    <Link to="#" className={`d-flex ${station.station_name === selectedButton ? 'active' : ''}`} onClick={() => handleButtonClick(station.station_name, station)}>
                                                                        <div> <img src={Offline} /> </div>
                                                                        <div>
                                                                            <h3>{station.station_name}</h3>
                                                                            <span>{station.handler_name}</span>
                                                                        </div>
                                                                    </Link>
                                                                </li>
                                                            </React.Fragment>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </Col>
                                            <Col md={9}>
                                                <div className='right_side'>

                                                    {selectedFeedback &&
                                                        <>
                                                            <div className='text-end mb-2'>
                                                                <Link to="#" className="expand border-0" onClick={showGalleryView}>Gallery View</Link>
                                                                <Link to='#' className="expand" onClick={() => toggleExpandAll('stn')}>
                                                                    {expandedKeys.length === selectedFeedback?.handlerConversation?.length ? 'Collapse All' : 'Expand All'}
                                                                </Link>
                                                            </div>
                                                            <div className='chat_box'>
                                                                {selectedFeedback?.handlerConversation?.map((msg, index) => (
                                                                    <>
                                                                        <Accordion key={index} activeKey={expandedKeys} className={msg.sender_org_type === userDetails?.org_type ? '' : 'recever'}>
                                                                            <Accordion.Item eventKey={index.toString()}>
                                                                                <Accordion.Header onClick={() => toggleAccordionItem(index, msg, 'all')}>
                                                                                    <div><img src={Pack} /> {msg.sender_name}</div>
                                                                                    <div className='acorright'> {msg.sender_org_type === userDetails?.org_type ? '' : (msg.is_seen === 0 ? <span className='new_msgt'> <img src={Newon} /> </span> : '')}{msg.conversation_attachments?.length > 0 && <FontAwesomeIcon icon={faPaperclip} />}  <span>{msg.date} | {msg.time}</span></div></Accordion.Header>
                                                                                <Accordion.Body>
                                                                                    {msg.conversation_text}
                                                                                    {msg.conversation_attachments?.length > 0 &&
                                                                                        <div className='d-flex mt-1'>
                                                                                            {msg.conversation_attachments?.map((file, index) => {
                                                                                                const fileName = file?.file_name;
                                                                                                // console.log("🚀 ~ {files.map ~ file:", file)
                                                                                                const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                                                                const extension = fileName?.split(".").pop();
                                                                                                return (
                                                                                                    <>
                                                                                                        <div key={`ns_${index}`} className="mag_image">
                                                                                                            {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                                                                                            ) ? (
                                                                                                                <>
                                                                                                                    <img
                                                                                                                        src={file.file_path}
                                                                                                                        alt="Preview"
                                                                                                                        style={{
                                                                                                                            maxWidth: "30px",
                                                                                                                            maxHeight: "30px",
                                                                                                                            marginRight: "5px",
                                                                                                                        }}
                                                                                                                    // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                                                                    // onClick={() =>
                                                                                                                    //     handleFileClick(file.file_path)
                                                                                                                    // }
                                                                                                                    />
                                                                                                                </>
                                                                                                            ) : (
                                                                                                                <>
                                                                                                                    <span className="d-flex rafilename">
                                                                                                                        <img src={Docmnt} className="fileimg" />
                                                                                                                    </span>
                                                                                                                </>
                                                                                                            )}
                                                                                                            <span className="rafilename">
                                                                                                                {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                                                                                            </span>

                                                                                                            <button
                                                                                                                className="msg_download"
                                                                                                                type="button"
                                                                                                                onClick={() =>
                                                                                                                    handleDownload(file.file_path, file.file_name)
                                                                                                                }
                                                                                                            >
                                                                                                                <FontAwesomeIcon icon={faFileArrowDown} />
                                                                                                            </button>

                                                                                                        </div>
                                                                                                    </>
                                                                                                );
                                                                                            })}
                                                                                        </div>
                                                                                    }
                                                                                </Accordion.Body>
                                                                            </Accordion.Item>
                                                                        </Accordion>
                                                                    </>
                                                                ))}

                                                            </div>
                                                            <div>
                                                                <div className='d-flex reco_image'>
                                                                    {msgFiles.map((file, index) => {
                                                                        const fileName = file?.name;
                                                                        // console.log("🚀 ~ {files.map ~ file:", file)
                                                                        const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                                        const extension = fileName?.split(".").pop();
                                                                        return (
                                                                            <div key={index} className='img-thumbnail'>
                                                                                {file.type.startsWith('image/') ? (
                                                                                    <img
                                                                                        src={URL.createObjectURL(file)}
                                                                                        alt="Preview"
                                                                                        style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                                                                    />
                                                                                ) : (
                                                                                    <span className='d-flex'><img src={Docmnt} className='fileimg' />  </span>
                                                                                )}
                                                                                <span className="rafilename">
                                                                                    {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                                                                </span>
                                                                                <button className='dltbtn' type="button" onClick={() => msgHandleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>

                                                                <Form.Group className='massge_text'>
                                                                    <div className='mag_send'>
                                                                        <Link to='#' onClick={msgHandleBrowseFiles}> <FontAwesomeIcon icon={faPaperclip} /> </Link>
                                                                        <Button variant="primary" onClick={() => sendMessage('all')}><FontAwesomeIcon icon={faPaperPlane} /></Button>
                                                                        <input
                                                                            type="file"
                                                                            ref={msgFileInputRef}
                                                                            style={{ display: 'none' }}
                                                                            onChange={msgHandleFileChange}
                                                                            multiple
                                                                        />

                                                                    </div>
                                                                    <div className='send_msg'>
                                                                        Send message to: <span>{selectedFeedback.station_handler_name}</span>
                                                                    </div>
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        placeholder='Enter a description...'
                                                                        rows={2}
                                                                        name='conversation_text'
                                                                        onChange={conversationChange}
                                                                        value={msgFormData.conversation_text || ''}
                                                                    />
                                                                </Form.Group>
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </Col>
                            <Col sm='3'>
                                <div className='missing_info h-100 recover_right my-3'>
                                <div className='mb-3'>
                                        <h4>Airline Highlighted Image(s)</h4>
                                        {selectedFeedback?.attachments && (
                                            <div className='main_primary'>
                                                {findPrimary.map((file, index) => {
                                                    const fileName = file?.file_name;
                                                    // console.log("🚀 ~ {files.map ~ file:", file)
                                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                    const extension = fileName?.split(".").pop();
                                                    return (
                                                        <>
                                                            <div key={`ns_${index}`} className='primary_image'>
                                                                {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                                                ) ? (
                                                                    <div>
                                                                        <img
                                                                            src={file.file_path}
                                                                            alt="Preview"
                                                                            style={{
                                                                                maxWidth: "100%",
                                                                                maxHeight: "100%",

                                                                            }}
                                                                            // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                            onClick={() =>
                                                                                handleImageClick(file.file_path)
                                                                            }
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <>
                                                                        <span className="">
                                                                            <img src={Docmnt} className="fileimg" />
                                                                        </span>
                                                                    </>
                                                                )}
                                                                <span className="rafilename">
                                                                    {baseName?.length <= 5 ? fileName : `${baseName?.substring(0, 5)}... .${extension}`}
                                                                </span>
                                                                {/* <Link to="/" className="slide_dwnldbtn" onClick={() => handleDownload(file.file_path, file.file_name)}>
                                                                                    <FontAwesomeIcon icon={faDownload} />
                                                                                </Link> */}

                                                                {/* {1 === 1 && ( */}
                                                                {/* {file.is_comment !== 1 &&
                                                                            file.is_editable === 1 && ( */}
                                                                {/* <button
                                                                            className="dltbtn"
                                                                            type="button"
                                                                            onClick={() =>
                                                                                handleDeleteImage(index, file.id, file.attachment_type)
                                                                            }
                                                                        >
                                                                            <FontAwesomeIcon icon={faCircleXmark} />
                                                                        </button> */}
                                                                {/* )} */}
                                                            </div>
                                                        </>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                    <hr />
                                    <h4>Recovery Information</h4>
                                    <ul>
                                        <li>
                                            <span>Master Airway Bill :</span> <span> {recoveryDetails?.master_airway_bill_prefix} - {recoveryDetails?.master_airway_bill_no}</span>
                                        </li>
                                        <li>
                                            <span>Flight Number :</span> <span> {recoveryDetails?.flight_prefix} - {recoveryDetails?.flight_no}</span>
                                        </li>
                                        <li>
                                            <span>Flight Date :</span> <span> {recoveryDetails?.flight_date}</span>
                                        </li>
                                        <li>
                                            <span>Created Date :</span> <span> {recoveryDetails?.created_date}</span>
                                        </li>
                                        {/* <li>
                                            <span>Created By :</span> <span> {recoveryDetails?.created_by}</span>
                                        </li> */}
                                    </ul>
                                    <hr />
                                    <h4>Incident Information</h4>
                                    <ul>
                                        <li>
                                            <span>Total MAWB Pieces :</span> <span> {recoveryDetails?.total_mawb_pieces}</span>
                                        </li>
                                        <li>
                                            <span>Weight (Kg) :</span> <span> {recoveryDetails?.total_mawb_wght}</span>
                                        </li>
                                        <li>
                                            <span>Pieces involved :</span> <span> {recoveryDetails?.pieces_involved}</span>
                                        </li>
                                        <li>
                                            <span>Involved Weight (Kg) :</span> <span> {recoveryDetails?.pieces_wght}</span>
                                        </li>
                                        <li>
                                            <span>Recovery Aspects :</span> <span> {recoveryDetails?.recovery_aspects_text}</span>
                                        </li>
                                        <li>
                                            <span>Status :</span> <span> {recoveryDetails?.status}</span>
                                        </li>
                                        {recoveryDetails?.updated_by &&
                                            <li>
                                                <span>Updated By :</span> <span> {recoveryDetails?.updated_by}</span>
                                            </li>
                                        }
                                        <li>
                                            <span className='d-block'>Comment :</span> <span> {recoveryDetails?.comment}</span>
                                        </li>
                                    </ul>
                                </div>
                            </Col>
                        </Row>

                        {/* </div> */}
                    </div>
                </div>
                <Modal show={galleryViewOpen} onHide={galleryViewclose} className="addfrom change_type" centered size="xl">
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body>
                        <div className="d-flex justify-content-between">
                            <div className="attchment">
                                <h3>
                                    Recovery Case {/* attachment_no ? attachment_no : (group_id ? '' : attachable_id) */}
                                    <span>
                                        Attachments
                                        <span className="rabadge badge bg-primary">
                                            {galleryFiles?.length}
                                        </span>
                                    </span>
                                </h3>
                            </div>

                            <div className="gallery_download">
                                <button onClick={handleDeleteImageTop}>
                                    <img title="" src={Trash} /> <span>Delete</span>
                                </button>
                                <button onClick={multipleDownload}>
                                    <img src={Export} /> <span>Download</span>
                                </button>
                            </div>
                        </div>

                        <div className="my-3">
                            <Table className="gallery_view">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th>Name</th>
                                        <th>Document Type</th>
                                        <th>Size</th>
                                        <th>Date added</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {galleryFiles?.map((file, index) => {
                                        const fileName = file.file_name;
                                        const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                        const extension = fileName?.split(".").pop();

                                        return (
                                            <tr key={`gv${index}`}>
                                                <td>
                                                    {/* {console.log('attachment_no', file)} */}
                                                    <Form.Check // prettier-ignore
                                                        type="checkbox"
                                                        id="checkbox"
                                                        checked={selectedRows.some(
                                                            (row) => row.attachment_id === file.id
                                                        )}
                                                        onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                                    />
                                                </td>
                                                <td className="delimg">
                                                    <img src={Radown} onClick={() => handleDownload(file.file_path, file.file_name)} />
                                                </td>
                                                <td>
                                                    {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                                    ) ? (
                                                        <>
                                                            <img
                                                                src={file.file_path}
                                                                alt="Preview"
                                                                style={{
                                                                    maxWidth: "22px",
                                                                    maxHeight: "22px",
                                                                    marginRight: "10px",
                                                                }}
                                                                // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                onClick={() => handleFileClick(file.file_path)}
                                                            />
                                                            <span>
                                                                {/*file.file_name*/}
                                                                {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`}
                                                            </span>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <span className="d-flex rafilename">
                                                                <img src={Docmnt} className="fileimg" />
                                                                <span>{file.file_name}</span>
                                                            </span>
                                                        </>
                                                    )}
                                                    {/* <img src={Galpic} className='fileimg' /> {file.file_name} */}
                                                </td>
                                                <td>{file.file_type}</td>
                                                <td>{file.file_size}</td>
                                                <td>{file.upload_time}</td>
                                                <td className="delimg">
                                                    {/* {file.is_comment !== 1 && file.is_editable === 1 && ( */}
                                                    <img src={Bin} onClick={() => handleDeleteImage(index, file.id, file.attachment_type)} />
                                                    {/* )} */}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer></Modal.Footer>
                </Modal>
                <Modal show={imgShow} onHide={handleClose} centered className="imgmodal" size='lg'>
                <Modal.Header closeButton onClick={handleClose}></Modal.Header>
                <Modal.Body className='text-center'>
                    {/* {console.log(selectedFile)} */}
                    <img src={highlightedFile} className="img-fluid" alt="Selected" />

                </Modal.Body>
            </Modal>
            </div>
        </div>
    )
}

export default MessageRecovery;